import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import React, { useEffect, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { message as antdMessage } from "antd";
import ContactUs from "../../Assets/Images/ContactUsModal.svg";
import { useTranslation } from "react-i18next";
import { ContactUsPost } from "../../actions/ContactUs/ContactUsActions";
import { useDispatch } from "react-redux";
import ButtonRounded from "../Signature/button";

interface ContactUsModalProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}

const ContactUsModal: React.FC<ContactUsModalProps> = ({ open, setOpen }) => {
  const [loader, setLoader] = useState(false);
  const [email, setEmail] = useState("");
  const [reason, setReason] = useState("");
  const [message, setMessage] = useState("");
  const [errors, setErrors] = useState<Record<string, string>>({});

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const isValidEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  useEffect(() => {
    if (!open) {
      setLoader(false);
      setEmail("");
      setReason("");
      setMessage("");
    }
  }, [open]);
  const handleAction = async () => {
    setLoader(true);
    const newErrors: Record<string, string> = {};

    // Form validation checks
    if (!email || !isValidEmail(email)) {
      newErrors.email = t("RequiredFieldErrorEmail");
    }
    if (!reason) {
      newErrors.reason = t("RequiredFieldErrorReasonReason");
    }
    if (!message) {
      newErrors.message = t("RequiredFieldErrorMessage");
    }

    if (Object.keys(newErrors).length > 0) {
      setLoader(false);
      setErrors(newErrors);
      return;
    }

    setErrors({}); // Clear errors
    const data = {
      email,
      reason,
      message,
    };
    const success = await dispatch(ContactUsPost(data, setOpen));
    setLoader(false);
    if (success) {
      antdMessage.success(t("ContactUsSuccess"));
    } else {
      antdMessage.error(t("ContactUsError"));
    }
  };

  return (
    <Modal
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 800,
      }}
    >
      <Fade in={open}>
        <Row className="model p-0 w_40 contactUsModalWidth min_w_xs_0 w-xs-90 rounded_Contact m-0 ">
          <div className="w_38 contacUsModalbg d-none d-lg-flex align-items-center justify-content-center">
            <img className="w-100" src={ContactUs} alt="Contact Us" />
          </div>
          <Col className="w_90">
            <Row className="pe-5 py-4 my-2 ms-4 ps-2 ">
              <div className="productSansBold landing_banner_Heading line_height_100pc text_24">
                {t("Contact")}
                <span className="ms-1 text-black">{t("Contactspan")}</span>
              </div>
              <div className="contactUsDescription mt-1 mb-4 productSans text_13">
                {t("ContactDescription")}
              </div>
              <Form.Group className="mb-3">
                <Form.Label className="productSans text_14">
                  {t("Your email")}
                </Form.Label>
                <Form.Control
                  as="input"
                  size="lg"
                  className={`add_text_box min_h_content py-1 px-2 rounded ${
                    errors.email ? "is-invalid" : ""
                  }`}
                  onChange={(e) => {
                    e.preventDefault();
                    setErrors({ ...errors, email: "" });
                    setEmail(e.target.value);
                  }}
                  type="text"
                  value={email}
                />
                {errors.email && (
                  <div className="invalid-feedback productSans text_14 ">
                    {errors.email}
                  </div>
                )}
              </Form.Group>
              <Form.Group className="mb-2 pt-1">
                <Form.Label className="productSans text_14">
                  {t("Reason for contacting")}
                </Form.Label>
                <Form.Select
                  size="lg"
                  className={`add_text_box min_h_content py-1 px-2 rounded add_text_boxArrow ${
                    errors.reason ? "is-invalid" : ""
                  }`}
                  onChange={(e) => {
                    e.preventDefault();
                    setReason(e.target.value);
                    setErrors({ ...errors, reason: "" });
                  }}
                  value={reason}
                >
                  <option value="">{t("Select a reason")}</option>
                  <option value="Question">{t("Question")}</option>
                  <option value="Report">{t("Report")}</option>
                  <option value="Others">{t("Others")}</option>
                </Form.Select>
                {errors.reason && (
                  <div className="invalid-feedback productSans text_14">
                    {errors.reason}
                  </div>
                )}
              </Form.Group>
              <Form.Group className="mb-3 h_max pt-1">
                <Form.Label className="productSans text_14">
                  {t("Message")}
                </Form.Label>
                <Form.Control
                  as="textarea"
                  rows={6}
                  style={{ resize: "none" }}
                  size="lg"
                  className={`add_text_box min_h_content py-1 px-2 rounded ${
                    errors.message ? "is-invalid" : ""
                  }`}
                  onChange={(e) => {
                    e.preventDefault();
                    setMessage(e.target.value);
                    setErrors({ ...errors, message: "" });
                  }}
                  type="text"
                  value={message}
                />
                {errors.message && (
                  <div className="invalid-feedback productSans text_14">
                    {errors.message}
                  </div>
                )}
              </Form.Group>
              <ButtonRounded
                onclick={handleAction}
                text={"Submit"} // Use translated text
                style={"w_edit_button"}
                loader={loader}
              />
              {/* <ButtonRounded
                onclick={handleAction}
                text={t("Submit")} // Use translated text
                style={"w_edit_button"}
              /> */}
            </Row>
          </Col>
        </Row>
      </Fade>
    </Modal>
  );
};

export default ContactUsModal;
